import { render } from "./modifypassword.vue?vue&type=template&id=8c8a24c0"
import script from "./modifypassword.vue?vue&type=script&lang=js"
export * from "./modifypassword.vue?vue&type=script&lang=js"

import "./modifypassword.vue?vue&type=style&index=0&id=8c8a24c0&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__